/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Connector_UnavailableInputs */



/**
* | output |
* | --- |
* | "The source could not be reached while this file was being indexed. Retry once it is available again." |
*
* @param {Embedding_Error_Connector_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_connector_unavailable = /** @type {((inputs?: Embedding_Error_Connector_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Connector_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Quelle war beim Indexieren dieser Datei nicht erreichbar. Versuchen Sie es erneut, sobald sie wieder verfügbar ist.")
	return /** @type {LocalizedString} */ ("The source could not be reached while this file was being indexed. Retry once it is available again.")
});